import React from 'react';
import './TableFilterBar.css';

const TableFilterBar = ({ filters, currentFilters, onFilterChange }) => {
  if (!filters || filters.length === 0) return null;

  return (
    <div className="table-filter-bar">
      {filters.map((filter) => (
        <div key={filter.key} className="filter-group">
          <label htmlFor={filter.key}>{filter.label}:</label>
          <select
            id={filter.key}
            value={currentFilters[filter.key] || ''}
            onChange={(e) => onFilterChange(filter.key, e.target.value)}
          >
            <option value="">All</option>
            {/* This is to allow boolean filters to be shown as a easy-to-understand label instead of true or false */}
            {filter.options.map((option) =>
                typeof option === 'object' ? (
                    <option key={option.value} value={option.value}>
                    {option.label}
                    </option>
                ) : (
                    <option key={option} value={option}>
                    {option}
                    </option>
                )
            )}
          </select>
        </div>
      ))}
    </div>
  );
};

export default TableFilterBar;
